import { getEnvs } from "@app/common/utils/getEnvs";
import Cookies from "js-cookie";

interface IUserData {
  token: string;
  idUser: string;
  idAccount: string;
  userImage: string;
  idProfile: string;
  fullNameUser: string;
}

interface IModuleData {
  idModule: string;
  nameModule: string;
}

interface IDataBiowel extends IUserData, IModuleData {}

type TDataBiowel = Omit<IDataBiowel, "nameModule">;

const { DOMAIN } = getEnvs();

const EMPTY_USER_DATA = {
  token: "",
  idUser: "",
  idAccount: "",
  userImage: "",
  idProfile: "",
  fullNameUser: "",
  idModule: "",
  nameModule: "",
  myPayroll: "",
  mySetting: "",
  dataPolicy: "",
  redirect: ""
};

export const getUserDataFromCookies = (): typeof EMPTY_USER_DATA => {
  try {
    const redirectData = Cookies.get("redirectData");
    if (redirectData) {
      const parsed = JSON.parse(redirectData);
      if (parsed && typeof parsed === "object") {
        return { ...EMPTY_USER_DATA, ...parsed };
      }
    }
  } catch {
    // cookie corrupta — la ignoramos
  }

  return { ...EMPTY_USER_DATA };
};

export const clearUserDataFromCookies = () => {
  Cookies.remove("token", { secure: true, sameSite: "None", domain: DOMAIN });
  Cookies.remove("idUser", { secure: true, sameSite: "None", domain: DOMAIN });
  Cookies.remove("idAccount", { secure: true, sameSite: "None", domain: DOMAIN });
  Cookies.remove("userImage", { secure: true, sameSite: "None", domain: DOMAIN });
  Cookies.remove("idProfile", { secure: true, sameSite: "None", domain: DOMAIN });
  Cookies.remove("fullNameUser", { secure: true, sameSite: "None", domain: DOMAIN });
  Cookies.remove("nameModule", { secure: true, sameSite: "None", domain: DOMAIN });
  Cookies.remove("idModule", { secure: true, sameSite: "None", domain: DOMAIN });
  Cookies.remove("redirectData", { secure: true, sameSite: "None", domain: DOMAIN });
  Cookies.remove("token", { secure: true, sameSite: "None", domain: DOMAIN });
  Cookies.remove("idUser", { secure: true, sameSite: "None", domain: DOMAIN });
};

export const saveUserNewRoleAndAccount = ({
  token,
  idAccount,
  idProfile
}: {
  token: string;
  idAccount: string;
  idProfile: string;
}) => {
  Cookies.set(
    "redirectData",
    JSON.stringify({ ...getUserDataFromCookies(), token, idAccount, idProfile }),
    {
      expires: 1,
      secure: true,
      sameSite: "None",
      domain: DOMAIN
    }
  );

  Cookies.set("token", token, {
    expires: 1,
    secure: true,
    sameSite: "None",
    domain: DOMAIN
  });

  Cookies.set("idAccount", idAccount, {
    expires: 1,
    secure: true,
    sameSite: "None",
    domain: DOMAIN
  });

  Cookies.set("idProfile", idProfile, {
    expires: 1,
    secure: true,
    sameSite: "None",
    domain: DOMAIN
  });
};

export const saveRedirectDataToCookies = (userData: IUserData, moduleData: IModuleData) => {
  const redirectData = {
    token: userData.token,
    idUser: userData.idUser,
    idAccount: userData.idAccount,
    userImage: userData.userImage,
    idProfile: userData.idProfile,
    fullNameUser: userData.fullNameUser,
    idModule: moduleData.idModule,
    nameModule: moduleData.nameModule
  };

  Cookies.set("redirectData", JSON.stringify(redirectData), {
    expires: 1,
    secure: true,
    sameSite: "None",
    domain: DOMAIN
  });
};

export const saveUserDataToCookiesRedirect = (data: IModuleData) => {
  const { idModule, nameModule } = data;

  // Guardamos los datos del módulo en cookies
  Cookies.set("idModule", idModule, { expires: 1, secure: true, sameSite: "None", domain: DOMAIN });
  Cookies.set("nameModule", nameModule, {
    expires: 1,
    secure: true,
    sameSite: "None",
    domain: DOMAIN
  });
};

export const saveUserDataToCookies = (data: TDataBiowel) => {
  const { token, idUser, idAccount, userImage, idProfile, fullNameUser } = data;

  // Guardamos los datos en cookies de forma individual
  Cookies.set("token", token, { expires: 1, secure: true, sameSite: "None", domain: DOMAIN });
  Cookies.set("idUser", idUser, { expires: 1, secure: true, sameSite: "None", domain: DOMAIN });
  Cookies.set("idAccount", idAccount, {
    expires: 1,
    secure: true,
    sameSite: "None",
    domain: DOMAIN
  });

  Cookies.set("userImage", userImage, {
    expires: 1,
    secure: true,
    sameSite: "None",
    domain: DOMAIN
  });

  Cookies.set("idProfile", idProfile, {
    expires: 1,
    secure: true,
    sameSite: "None",
    domain: DOMAIN
  });

  Cookies.set("fullNameUser", fullNameUser, {
    expires: 1,
    secure: true,
    sameSite: "None",
    domain: DOMAIN
  });
};
